'use strict';

var NetworkError = require('./NetworkError.js');

class BadRequestError extends NetworkError.NetworkError {
    code;
    target;
    details;
    constructor(params) {
        const { code, target, details, message = 'Bad request' } = params;
        super(message, 400);
        this.code = code;
        this.target = target;
        this.details = details;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            code: this.code,
            target: this.target,
            details: this.details,
        };
    }
}

exports.BadRequestError = BadRequestError;
//# sourceMappingURL=BadRequestError.js.map
